// extracted by mini-css-extract-plugin
export default {"Window":"fxcard_Window__6zf7P","WindowContent":"fxcard_WindowContent__wV92J","WindowBg":"fxcard_WindowBg__AliBe"};